document.addEventListener('DOMContentLoaded', function () {
    const languageDropdownItems = document.querySelectorAll('.dropdown-item[data-lang]');
    const currentLangSpan = document.getElementById('current-lang');

    function getCurrentCulture() {
        const pathSegments = window.location.pathname.split('/').filter(segment => segment);
        if (pathSegments.length > 0) {
            const first = pathSegments[0].toLowerCase();
            if (first === 'es') return 'es';
            if (first === 'en') return 'en';
        }
        return 'pt-BR';
    }

    function setCultureCookie(culture) {
        const cookieValue = `c=${culture}|uic=${culture}`;
        document.cookie = `.AspNetCore.Culture=${encodeURIComponent(cookieValue)}; path=/; max-age=31536000; SameSite=Lax`;
    }

    function buildLocalizedUrl(newCulture) {
        const currentPath = window.location.pathname;
        let pathSegments = currentPath.split('/').filter(segment => segment);
        
        if (pathSegments.length > 0) {
            const first = pathSegments[0].toLowerCase();
            if (first === 'es' || first === 'en' || first === 'pt-br') {
                pathSegments.shift();
            }
        }

        const rest = pathSegments.length > 0 ? '/' + pathSegments.join('/') : '';
        return (newCulture === 'pt-BR' ? (rest || '/') : '/' + newCulture + rest) + window.location.search + window.location.hash;
    }

    languageDropdownItems.forEach(item => {
        item.addEventListener('click', function (e) {
            e.preventDefault();
            const selectedLang = this.getAttribute('data-lang');
            if (selectedLang === getCurrentCulture()) return;
            
            setCultureCookie(selectedLang);
            window.location.href = buildLocalizedUrl(selectedLang);
        });
    });

    // Sync cookie on load to ensure server-side consistency
    setCultureCookie(getCurrentCulture());
});
